import type maplibregl from "maplibre-gl";
import type { MapLibreInstanceService } from "../../../../core/MapLibreInstanceService";

class HoverController {
	private mapLibreInstanceService: MapLibreInstanceService;

	public hoverableLayers: Array<string> = [];

	#hoveredFeatures: Array<maplibregl.MapGeoJSONFeature> = [];
	public get hoveredFeatures() {
		return this.#hoveredFeatures;
	}

	constructor({ mapLibreInstanceService }: { mapLibreInstanceService: MapLibreInstanceService }) {
		this.mapLibreInstanceService = mapLibreInstanceService;
	}

	/** */
	public update(point: maplibregl.Point): void {
		this.clear();

		const hoveredFeatures = this.mapLibreInstanceService.map.queryRenderedFeatures(point, {
			layers: this.hoverableLayers,
		});

		for (const feature of hoveredFeatures) {
			this.mapLibreInstanceService.map.setFeatureState(feature, { hover: true });
		}

		this.#hoveredFeatures = hoveredFeatures;
	}

	/** */
	public clear(): void {
		for (const feature of this.hoveredFeatures) {
			this.mapLibreInstanceService.map.setFeatureState(feature, { hover: false });
		}

		this.#hoveredFeatures = [];
	}
}

export { HoverController };
